<template>
  <div id="graphic-static-issues">
    <div class="mar-b-30">
      <line-chart></line-chart>
    </div>
  </div>
</template>

<script>
import main from './main'

export default main
</script>

